
import Vue from 'vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import BravadoText from '@/components/common/BravadoText/BravadoText.vue';

export default Vue.extend({
  name: 'PublicPortfolioClaim',
  components: { BravadoButtonV3, BravadoText },
  methods: {
    handleJoinNowClick() {
      this.$analytics.logEvent('public-portfolio__join-now__click');

      this.$utils.routePushWithQuery({
        query: { dynamic_modal: this.$constants.dynamicModals.SIGN_UP_MODAL },
      });
    },
  },
});
